import { GenericLazyString } from '@eventbrite/i18n';
import { Typography } from '@eventbrite/marmalade';
import React, { useState } from 'react';
import { OperatingHoursButton } from '../../../components/OperatingHoursButton';
import { OperatingHoursModal } from '../../../components/OperatingHoursModal';
import { ResponsiveSection } from '../../ResponsiveSection';
import { MapPinIcon } from './MapPinIcon';

import './AboutPOICard.scss';

export interface AboutPOICardProps {
    title: string | GenericLazyString;
    content: string | GenericLazyString;
    address: string;
    openingHours?: Array<string>;
}

/**
 * About Card which shows Title, Content/Description, Address for a Point of Interest(POI)
 */
export const AboutPOICard: React.FC<AboutPOICardProps> = (props) => {
    const { title, content, address, openingHours } = props;
    const [isShown, updateArgs] = useState(false);
    const toggleModal = () => {
        updateArgs((isShown) => !isShown);
    };

    return (
        <ResponsiveSection>
            <div className="poi-about eds-l-pad-all-8 eds-l-mar-bot-20">
                <Typography
                    align="left"
                    as="h2"
                    color="neutral-1000"
                    variant="heading-sm"
                    className="eds-l-pad-bot-6"
                >
                    {title}
                </Typography>
                <Typography
                    align="left"
                    as="p"
                    color="neutral-800"
                    variant="body-md"
                    className="poi-about__content eds-text-color--grey-800 eds-l-pad-bot-5"
                >
                    {content}
                    <br />
                    <br />
                </Typography>
                <div>
                    {openingHours && openingHours.length > 0 ? (
                        <>
                            <OperatingHoursModal
                                isShown={isShown}
                                openings={openingHours}
                                handleClose={toggleModal}
                            />
                            <OperatingHoursButton onClick={toggleModal} />
                        </>
                    ) : null}
                </div>
                <div className="eds-align--center-vertical">
                    <div className="poi-about__address-icon">
                        <MapPinIcon />
                    </div>
                    <p className="poi-about__address eds-g-group eds-text-bm eds-text-weight--heavy eds-text--left eds-l-mar-left-2">
                        {address}
                    </p>
                </div>
            </div>
        </ResponsiveSection>
    );
};
